var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"total":_vm.total,"current-page":_vm.page,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"search-config":_vm.searchConfig,"loading":_vm.loading},on:{"onChangePage":_vm.changeCurrentPage,"onSearch":_vm.onSearch,"onHandle":_vm.onHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }